import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import moment from 'moment-timezone';

import DatePicker from '../../shared/datePick/DatePick';
import RenderIf from '../../renderIf/RenderIf';
import DateTimeText from '../../shared/DateTimeText';
import useTenDayTimeline from './useTenDayTimeline';
import { ProtectedRouteContext } from '../../Context';

const TenDayTimelineEdit = ({ appInstId, questionId, date, onSave }) => {
    const { userSettings } = React.useContext(ProtectedRouteContext);
    const [selectedDate, setSelectedDate] = React.useState(moment.tz(date, userSettings?.ClientTimeZone));
    const [isEditable, setIsEditable] = React.useState(false);

    const { doingAjax, updateTenDayTimeline } = useTenDayTimeline(appInstId, questionId);

    const handleChange = (newVal) => {
        setSelectedDate(moment.tz(newVal, userSettings?.ClientTimeZone));
    };

    return (
        <Box>
            <RenderIf isTrue={!isEditable}>
                <RenderIf isTrue={!!date}>
                    <DateTimeText date={moment.tz(date, userSettings?.ClientTimeZone)} />
                </RenderIf>

                <RenderIf isTrue={!date}>
                    <Typography>--/--/----</Typography>
                </RenderIf>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'right',
                    }}
                >
                    <LinkButton onClick={() => setIsEditable(true)}>Edit</LinkButton>
                </Box>
            </RenderIf>

            <RenderIf isTrue={isEditable}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: (theme) => theme.spacing(2),
                    }}
                >
                    <DatePicker
                        value={selectedDate}
                        onChange={handleChange}
                        size="small"
                        slotProps={{
                            openPickerButton: {
                                color: 'primary',
                            },
                        }}
                        saving={doingAjax}
                    />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'right',
                        gap: (theme) => theme.spacing(2),
                    }}
                >
                    <LinkButton
                        onClick={() => setIsEditable(false)}
                        size="small"
                        disabled={doingAjax}
                    >
                        Cancel
                    </LinkButton>

                    <LinkButton
                        onClick={() => handleChange(null)}
                        size="small"
                        color="warning"
                        disabled={!selectedDate || doingAjax}
                    >
                        Clear
                    </LinkButton>

                    <LinkButton
                        onClick={async () => {
                            let { succeeded, newDate } = await updateTenDayTimeline(selectedDate);
                            if (succeeded) {
                                onSave?.(newDate);
                                setIsEditable(false);
                            }
                        }}
                        disabled={doingAjax}
                    >
                        Save
                    </LinkButton>
                </Box>
            </RenderIf>
        </Box>
    );
};

const LinkButton = (props) => {
    return (
        <Button
            {...props}
            size="small"
            sx={{
                minWidth: 'unset',
                background: 'none',
                border: 'none',
                margin: 0,
                padding: 0,
                '&:hover': {
                    backgroundColor: 'unset',
                    textDecoration: 'underline',
                },
            }}
        />
    );
};

export default TenDayTimelineEdit;
